import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import moment from 'moment';

class FacturasCredito extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'Ventas', saveUrl: 'Ventas/save', backUrl: '/Catalogo' },
      new Form([
        Form.Field('date', 'startDate', 'Fecha Inicial', '', [Validators.required], 6),
        Form.Field('date', 'endDate', 'Fecha Final', '', [Validators.required], 6),
        Form.Field('select', 'type', 'Tipo', '', [Validators.required], 6, 
        [
          { Label: 'Contado', Value: '1' },
          { Label: 'Credito', Value: '2' },
        ]),
      ], ['Descargar Excel'], 'Pagos Pendientes Timbrar'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  onSubmit = async (i, vals) => {
    this.setState({ loading: true });
    const { startDate, endDate, type } = vals;
    const start = moment(startDate).format('YYYY-MM-DD')
    const end = moment(endDate).format('YYYY-MM-DD')
    const Resp = await Http.get(`pago/reporte/pagos-reportes?q=1&report_type=5&start_date=${start}&end_date=${end}&type=${type}`, true, 'arraybuffer')
    if (Resp) {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
      const url = URL.createObjectURL(blob)

      const link = document.createElement('a');
      link.href = url;
      link.download = 'pendientes_timbrar.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(FacturasCredito)
